<template>
  <div class="uvindex-yarly-page mt-4">
    <form action="?" class="form-clear mb-1"  v-if="allYears.length > 0">
        <label class="w50 fl tr" for="rok">Rok:</label>

        <select class="w75 fl" v-model="selectedYear" id="rok">
          <option v-for="option_year in allYears" v-bind:value="option_year">
            {{ option_year }}
          </option>
        </select>
        <span v-if="isLoading" class="pl-2">Načítavam...</span>
      <div class="clearfix"></div>
    </form>
    <div class="clearfix"></div>
    <div class="error" v-if="isError">{{ errorMsg }}</div>
    <div class="clearfix"></div>
    <template v-if="yearlyData.length && !isError">
      <highcharts ref="uvYearlyHighcharts" :updateArgs="[true, true, true]" :options="chartOptions"></highcharts>
    </template>


  </div>
</template>

<script>

import SHMUconf from '../shmu_conf';
import Axios from "axios";
import {Chart} from 'highcharts-vue'
import Highcharts from 'highcharts';

import UVIndexYearlyChart from './UVIndexYearly-chart-options'



Highcharts.setOptions({
  lang: {
    weekdays: ['Nedeľa','Pondelok', 'Utorok', 'Streda', 'Štvrtok', 'Piatok', 'Sobota'],
    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'Máj', 'Jún', 'Júl', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
    months: ['Január', 'Február', 'Marec', 'Apríl', 'Máj', 'Jún', 'Júl', 'August', 'September', 'Október', 'November', 'December']
  }
});



export default {
  components: {
    highcharts: Chart
  },
  name: 'UVIndexYearly',
  props: {
    station_id: Number
  },
  data() {
    return {
      selectedYear: null,
      allYears: [],
      yearlyDataLoaded: false,
      yearlyData: [],
      isError: false,
      errorMsg: null,
      isLoading: false,
      chartOptions: UVIndexYearlyChart,

    }
  },
  watch: {
    selectedYear() {
      this.getYearlyData();
    },
    station_id() {
      this.getYearlyData();
    }
  },
  mounted() {
    this.getYears();
  },
  computed: {

  },
  methods: {
    getYears() {
      const self = this;

      this.isLoading = true;
      Axios.get(SHMUconf.API_BASE_URL + 'uvindex/getmaxdatayears', {
        crossDomain: true,
        cache: false,
      }).then((response) => {
        if (!response.data.error) {
          self.allYears = response.data.available_max_data_years;
          self.selectedYear = self.allYears[0];
          self.isError = false;
          self.errorMsg = null;

        } else {
          self.isError = true;
          if (response.data.error[0].text) {
            self.errorMsg = response.data.error[0].text;
          } else {
            self.errorMsg = 'Nastala chyba pri načítavaní údajov!';
          }
        }
        self.isLoading = false;
      }).catch((error) => {
        self.isError = true;
        self.errorMsg = 'Nastala chyba pri komunikácii so serverom!';
        self.isLoading = false;
      });
    },

    getYearlyData() {
      const self = this;

      this.isLoading = true;
      Axios.get(SHMUconf.API_BASE_URL + 'uvindex/getmaxdata?station=' + this.station_id + '&rok=' + this.selectedYear, {
        crossDomain: true,
        cache: false,
      }).then((response) => {
        if (!response.data.error) {
          self.yearlyData = response.data;
          self.yearlyDataLoaded = true;
          this.isError = false;
          this.errorMsg = null;
          this.generateChart();

        } else {
          this.isError = true;
          if (response.data.error[0].text) {
            this.errorMsg = response.data.error[0].text;
          } else {
            this.errorMsg = 'Nastala chyba pri načítavaní údajov!';
          }
        }
        this.isLoading = false;
      }).catch((error) => {
        this.isError = true;
        this.errorMsg = 'Nastala chyba pri komunikácii so serverom!';
        this.isLoading = false;
      });

    },
    generateChart() {

      let uvdata_max = [], uvdata_p10 = [], uvdata_p90 = [], uvdata_med = [];

      // priprav data pre chart
      if (this.yearlyData.length > 0) {
        this.yearlyData.forEach((item) => {
          if (item.uvi_max !== null) item.uvi_max = parseFloat(item.uvi_max);
          if (item.uvi_med !== null) item.uvi_med = parseFloat(item.uvi_med);
          if (item.uvi_p10 !== null) item.uvi_p10 = parseFloat(item.uvi_p10);
          if (item.uvi_p90 !== null) item.uvi_p90 = parseFloat(item.uvi_p90);
          uvdata_max.push([item.dt * 1000, item.uvi_max]);
          uvdata_med.push([item.dt * 1000, item.uvi_med]);
          uvdata_p10.push([item.dt * 1000, item.uvi_p10]);
          uvdata_p90.push([item.dt * 1000, item.uvi_p90]);
        });
      }

      let m1 = this.chartOptions.series.find(item => (item.id) === 'uvMax');
      m1.data = uvdata_max;
      let m2 = this.chartOptions.series.find(item => (item.id) === 'uvP10');
      m2.data = uvdata_p10;
      let m3 = this.chartOptions.series.find(item => (item.id) === 'uvP90');
      m3.data = uvdata_p90;
      let m4 = this.chartOptions.series.find(item => (item.id) === 'uvMed');
      m4.data = uvdata_med;

      this.chartOptions.title.text = 'Maximálny hodinový UV Index počas roka ' + this.selectedYear;



    }
  }
}
</script>

<style>
.mx-table-date th {
  border: 0px !important;
}
.mx-datepicker,
.mx-input { width: 120px !important; }

button:disabled,
button[disabled]{
  border: 1px solid #ccc;
  background-color: #f8f7f7 !important;
  background-image: unset;
  color: #b3b1b1;
}



</style>
